import React from "react";
import OtpPage from "../GuestUser/OtpPage";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
const ClientForgotPasswordOTP = (props) => {
    //Do not remove commented code. Currently API doesn't provide email and mobile number hence ageneric message is show
    const [timer, setTimer] = React.useState(true);
    const [resendOTPTimer, setResendOTPTimer] = React.useState(true);
    // const [mobile, setMobile] = React.useState<string>(
    //   locationState?.mobile.toString()
    // );
    const resendOTP = () => {
        let payload = {
            clientReq: {
                pan: props.resendOTPPayload.accountDetails.pan,
                accTyp: props.resendOTPPayload.accountDetails
                    .accTyp,
            },
            userID: props.resendOTPPayload.accountDetails.userID,
        };
        di.login.clientGenerateOTP(payload);
        setResendOTPTimer(true);
        setTimer(true);
    };
    // const [email, setEmail] = React.useState<string>(locationState?.emailID);
    // React.useEffect(() => {
    //   if (locationState && locationState.emailID && locationState.mobile) {
    //     setMobile(
    //       "*".repeat(8).concat(locationState.mobile.toString().substring(7))
    //     );
    //     const emailParts = locationState.emailID.split("@");
    //     emailParts[0].length > 0 &&
    //       setEmail(
    //         emailParts[0]
    //           .substring(0, 3)
    //           .concat("*".repeat(emailParts[0].length - 3))
    //           .concat("@" + emailParts[1])
    //       );
    //   }
    // }, [locationState]);
    return (React.createElement("div", null,
        React.createElement(OtpPage, { pageheading: "Forgot Password", otpText: "registered mobile number and email ID", showTimer: timer, setTimer: setTimer, customResendOTP: resendOTP, resendOTPTimer: resendOTPTimer, setResendOTPTimer: setResendOTPTimer, errorState: (otp) => {
                if (otp.toString().length != 4)
                    return false;
                return true;
            }, HideSubmitButton: true, ParentclassName: "px-0", setOTP: props.setotp, timerValues: { min: 9, sec: 59 } }),
        resendOTPTimer && (React.createElement("div", { className: "d-flex justify-content-center DMSanN_14_400 text-success" }, "OTP successfully sent."))));
};
export default ClientForgotPasswordOTP;
